module.exports = __webpack_public_path__ + "static/media/Edit2.03d72416.svg";